export default "__VITE_ASSET__cdc88397__"